<template>
  <Card dis-hover>
    <div slot="title">
      <slot name="title"></slot>
      <p class="title-item">{{ this.$t('common.this_month') }}</p>
    </div>
    <!-- <a href="#" slot="extra">
      <slot name="extra"></slot>
    </a> -->
    <!-- 门店得分 -->
    <div class="top-line">
      <p>
        <!-- <span class="title">{{ $t('common.store_score') }}</span
        ><Icon
          size="16"
          :title="$t('common.store_score_desc')"
          type="ios-information-circle-outline"
        /> -->
      </p>
      <!-- <Select
        v-model="sortWay"
        :transfer="false"
        style="width: 80px; height: 32px"
        @on-change="sortChange"
      >
        <Option value="desc" key="top">TOP</Option>
        <Option value="asc" key="last">LAST</Option>
      </Select> -->
    </div>
    <div class="content">
      <board-one-item
        v-for="(item, index) in StoreList"
        :key="item.id"
        :storeItem="item"
        :storeIndex="index"
        :currentPage="currentPage"
      ></board-one-item>
      <Spin size="large" v-if="isLoading" fix></Spin>
      <div v-if="!isLoading && (!StoreList || StoreList.length === 0)" class="no-data">
        {{ $t('common.no_data') }}
      </div>
    </div>
    <div style="display: flex; justify-content: space-around; margin-top: 10px" class="bottom-item">
      <Page :total="totalPage" :page-size="5" :current="currentPage" size="small" @on-change="getData" />
    </div>
  </Card>
</template>
<script>
import boardOneItem from './boardOneItem.vue';
import api from '../../../api/home/index';

export default {
  components: {
    boardOneItem,
  },
  props: {},
  computed: {
    StoreList() {
      if (this.currentPage === 1) {
        return this.allData.slice(0, this.currentPage * 5);
      } else {
        return this.allData.slice((this.currentPage - 1) * 5, this.currentPage * 5);
      }
    },
  },
  data() {
    return {
      sortWay: 'desc',
      totalPage: null,
      currentPage: 1,
      isLoading: false,
      timerPage: null, //切换分页定时器
      timerData: null, //请求数据定时器
      currentDataPage: 1,
      allData: [],
    };
  },
  mounted() {
    this.getData();
  },
  beforeDestroy() {
    clearInterval(this.timerPage);
    clearInterval(this.timerData);
  },
  methods: {
    // 分页
    getData() {
      this.isLoading = true;
      // console.log(this.StoreList[4]);
      let params = {
        timeRange: 5,
        tagIdList: [],
        sourceTypeList: [],
        showCompare: 0,
        deptNode: [],
        checkerType: 2,
        role: [],
        user: [],
        templateId: [],
        sort: 'desc',
        pageNumber: this.currentDataPage,
        pageSize: 70,
      };

      this.pageShopScore(params).then(() => {
        if (!this.timerPage) {
          this.timerPage = setInterval(() => {
            if (this.currentPage * 5 >= this.totalPage) {
              this.currentPage = 1;
            } else {
              this.currentPage++;
            }
          }, 5000);
        }
        if (!this.timerData) {
          this.timerData = setInterval(() => {
            if (this.currentDataPage * 70 >= this.totalPage) {
              clearInterval(this.timerData);
              return;
            } else {
              this.currentDataPage++;
            }
            this.getData();
          }, 60000);
        }
      });

      // console.log(a);
    },
    // 排序
    sortChange(value) {
      this.isLoading = true;
      // console.log(value);
      let params = {
        timeRange: 5,
        tagIdList: [],
        sourceTypeList: [],
        showCompare: 0,
        deptNode: [],
        checkerType: 2,
        role: [],
        user: [],
        templateId: [],
        sort: value,
        pageNumber: 1,
        pageSize: 70,
      };
      // console.log(this.totalPage);
      this.pageShopScore(params).then(() => {
        this.currentPage = 1;
      });
    },

    async pageShopScore(param) {
      let newParam = {
        ...param,
        // newShop:1
      };
      await api
        .pageShopScore(newParam)
        .then(data => {
          this.allData = [...this.allData, ...data.content];
          this.totalPage = data.totalCount;
          this.isLoading = false;
        })
        .catch(e => {
          console.log(e);
          clearInterval(this.timerPage);
          clearInterval(this.timerData);
          this.isLoading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep {
  .ivu-card-head p {
    width: auto;
  }
  .ivu-card-body {
    overflow-y: auto;
    padding-top: 0;
  }
}
.title-item {
  padding: 0 5px;
  height: 18px;
  background: rgba(255, 255, 255, 0.11);
  border-radius: 3px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 12px;
  color: #b2b2b2;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  margin-left: 6px;
}
.top-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative !important;
  .title {
    display: inline-block;
    margin-right: 5px;
    font-weight: 600;
    font-size: 16px;
    color: #333333;
  }
}

.content {
  .rank-index {
    display: inline-block;
    width: 22px;
    height: 22px;
    line-height: 22px;
    border-radius: 6px;
    background: #f0f0f0;
    color: #333333;
    text-align: center;
  }
  ::v-deep {
    .ivu-spin-fix {
      background: none !important;
    }
  }
}
.bottom-item {
  ::v-deep {
    .ivu-progress-outer {
      margin-top: 4px;
    }
    .ivu-page-prev {
      background: rgba(255, 255, 255, 0.1) !important;
    }
    .ivu-page-next {
      background: rgba(255, 255, 255, 0.1) !important;
    }
    .ivu-page-item {
      background: rgba(255, 255, 255, 0.1) !important;
    }
  }
}
</style>
